module.exports = __webpack_public_path__ + "img/logo-large.696acecd.png";